
import React,{ useEffect, useState } from 'react'
import Logo from '../images/FidelitusFMS.png'
import {BiLogoFacebook,BiLogoLinkedin} from 'react-icons/bi'
import {AiFillInstagram,AiFillYoutube} from 'react-icons/ai'
import {IoLogoWhatsapp} from 'react-icons/io'
import {IoCloseOutline} from 'react-icons/io5'
import {TbMenu} from 'react-icons/tb'
import {AiOutlineStepForward} from 'react-icons/ai';
import { Drawer } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaAngleDown } from "react-icons/fa";
import ScrollToTop from './ScrollToTop'
import { fidelitus_gallery_website_url, hrlabs_website_url, project_website_url, transaction_website_url } from '../constant/Appconstants'


export default function Navbar() {

  
  const navigator = useNavigate();
  const {pathname} = useLocation()

  const path = pathname

  const [step,setstep] = useState('')
  const [visible,setvisible] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null);

  

  const social_media = [
    {'icon':BiLogoFacebook,name:'Facebook',id:1,path:'https://www.facebook.com/Fidelitus/'},
    {'icon':AiFillInstagram,name:'Instagram',id:2,path:'https://www.instagram.com/fidelitus.corp/'},
    {'icon':BiLogoLinkedin,name:'LinkedIn',id:3,path:'https://in.linkedin.com/company/fidelituscorp-property-services-private-ltd'},
    {'icon':AiFillYoutube,name:'YouTube',id:4,path:'https://youtu.be/y-3CAl8M9yA'},
    {'icon':IoLogoWhatsapp,name:'WhatsApp',id:5,path:'https://api.whatsapp.com/send?phone=919845062227&text=Hi%20I%20would%20like%20to%20connect%20with%20you'},
  ]

  const menu = [
    {name:'Home',path:'/home',id:1,menu:[]},
    {name:'About IFMS',path:'/about',id:2,menu:[]},
    {name:'Why us',path:'/why-us',id:3,menu:[]},
    {name:'Our Services',path:'/services',id:4,menu:[]},
    {name:'Fidelitus Group',path:'na',id:4,menu:[
      {
        id:1,
        name:'Real Estate Transaction',
        path:transaction_website_url,
        new:true
        // path:'/whats-more/real-estate-transaction'
    },
    {
      id:2,
      name:'Projects',
      path:project_website_url,
      new:true
      // path:'/whats-more/projects'
  },
    {
        id:3,
        name:'HR Labs',
        path:hrlabs_website_url,
        new:true
        // path:'/whats-more/hr-labs'
    },
   
    {
        id:4,
        name:'Fidelitus Gallery',
        path:fidelitus_gallery_website_url,
        new:true
        // path:'/whats-more/fidelitus-gallery'
    },
    ]},
    {name:'Blogs',path:'/blogs',id:5,menu:[]},
    {name:'Contact Us',path:'/contact',id:5,menu:[]},
    {name:'Careers',path:'/join_us',id:6,menu:[]},
  ]

  async function openPage(v){
    navigator(v)
    setvisible(false)
  }

  async function openPage1(v){
    if(v?.new === true){
      window.open(v?.path,'_blank')
      setvisible(false)
      setOpenDropdown(null)
    }else{
      navigator(v?.path)
      setvisible(false)
      setOpenDropdown(null)
    }
  }



  // fixed  shadow-sm 
  return (
    <div className='focus:outline-none focus:ring-0 z-100'>
    <ScrollToTop />
    <Drawer className='focus:outline-none focus:ring-0' open={visible} closable={false} mask={true} onClose={()=>setvisible(!visible)} maskClosable={true} width={280}>
      <div>
          <div className='flex justify-between items-center pb-2 border-b mb-5 border-slate-100'>
          <img src={Logo} alt="FidelitusHrLab" className='block w-[140px] h-[40px] -ml-4 md:ml-0 object-stretch cursor-pointer' />
          <IoCloseOutline size={25} onClick={()=>setvisible(!visible)} />
          </div>
          
          {menu?.map((m,i)=>(
          <div>  
          <div key={i} onClick={()=>m?.path === 'na' ?  i == step ? setstep('') : setstep(i) : openPage(m?.path)} className='border-b my-3 mb-1 pb-1  flex items-center justify-between'>
              <h6 className={` text-[13px] ${m?.path === path ? 'text-[#4190ac]' : 'text-slate-900'} font_normal font-[500] `}>{m?.name}</h6>
              <AiOutlineStepForward color="#4190ac" />
          </div>
          {m?.menu?.length > 0 && step === i && 
          <div className='ml-1'>
            {m?.menu?.map((m1)=>(
              <h6 onClick={()=>openPage1(m1)} className='cursor-pointer py-1.5 border-b border-slate-100 duration-300 text-gray-500 hover:text-[#027d9b] font-[600] text-[13px] font_bold'>{m1?.name}</h6>
            ))}
          </div>}   
          </div>
          ))}
      </div>

    </Drawer>
    <div className="min-w-screen w-full   ">
      <div className="min-w-screen border-b  border-slate-100 w-full   ">
        <div className='flex items-center w-[85vw]  mx-auto justify-end md:justify-between h-[50px]'>
        <a href='/'>
        <img src={Logo} alt="FidelitusHrLab" className='hidden md:block w-[150px] h-[40px] py-[2px] object-contain cursor-pointer' />
        </a>
        <div className='hidden md:flex h-full items-center justify-between'>

        {menu?.map((m,i)=>(
           <div onMouseLeave={()=>setOpenDropdown(null)} onMouseOver={()=>m?.menu?.length > 0  ? setOpenDropdown(i) : setOpenDropdown(null)} className='group relative z-20'>
           <h6 onClick={()=>m?.path !== 'na' && openPage(m?.path)} key={m?.id} className={`flex items-center  font_thicker text-[12px] py-4 font-[500] text-gray-800 cursor-pointer px-4  after:bg-[#4190ac] after:absolute after:h-[4px] after:w-0 after:bottom-[-1.5px] after:left-0  hover:after:w-full after:transition-all after:duration-300 ${m?.path === path ? 'border-b-[4px] border-[#4190ac]' : ''} `}>{m?.name} {m?.menu?.length > 0 && <FaAngleDown className='ml-[5px]'/>}</h6>
           {m?.menu?.length > 0 &&
              <div className={`${openDropdown === (i) ? 'block' : 'hidden'} absolute top-[50px] ml-[0px] w-[230px] border bg-white`}>
                  {m?.menu?.map((m1)=>(
                  <h6 onClick={()=>{openPage1(m1)}} key={m?.id} className={`capitalize hover:text-[#027d9b] border-b border-slate-100 text-[12px]  py-2 font-[500] text-gray-800 cursor-pointer px-4 relative  font_thicker `}>{m1?.name}</h6>
                  ))}
              </div>
            }
        </div>
          ))}


       
        </div>

        
        <div className='flex h-full items-center'>
            {social_media?.map((item,index)=>(
              <a key={item?.id}  className='h-full' href={item?.path} target='_blank'>
               <h6 className={`px-2 flex font_normal items-center h-full  text-slate-700 hover:bg-[#4190ac] hover:text-white border-r ${index == 0 && 'border-l'} border-slate-100`}>
               <item.icon  className='cursor-pointer'  />
              </h6>
              </a>
            ))} 
        </div>
        </div>
      </div>
      {/* <div className='w-[85vw]  flex  mx-auto justify-between'>
        <div className='hidden md:flex'>
         {menu?.map((m)=>(
           <h6 onClick={()=>router.push(m?.path)} key={m?.id} className={`text-[12px] py-2 font-[500] text-gray-800 cursor-pointer px-4 relative after:bg-[#4190ac] after:absolute after:h-[2px] after:w-0 after:bottom-0 after:left-0  hover:after:w-full after:transition-all after:duration-300 ${m?.path === path ? 'border-b-[2px] border-[#4190ac]' : ''} `}>{m?.name}  </h6>
         ))}
         </div>
         <h6 className='hidden md:block cursor-pointer text-[12px] py-2 text-white uppercase px-2 bg-[#4190ac]'>Get In Touch</h6>
      </div> */}

      <div className='w-[85vw] mx-auto flex  items-center justify-between md:hidden py-2'>
      <a href='/'>
      <img src={Logo} alt="FidelitusHrLab" className='w-[140px] h-[40px] -ml-4 md:ml-0 py-[2px] object-stretch cursor-pointer' />
      </a>  
      <TbMenu onClick={()=>setvisible(!visible)} className='text-slate-700' />
      </div>
     </div>
    </div>
  )
}
